@let config = this.config();
@let voucherFormModel = this.formModel();
@let codeValidity = this.codeValidity();
@let warningItem = this.warningItem();
@let isWienerLinienVoucher = this.isWienerLinienVoucher();
@let wienerLinienVoucherDetail = this.wienerLinienVoucherDetail();

@if (config) {
  <mwe-basic-card
    [iconClass]="'fa-gift-card'"
    [cardTitle]="'newVoucher.title'"
    [hasBackground]="true"
    [headingNodeType]="config.headingNodeType"
  >
    <mwe-form #form [formModel]="voucherFormModel" (formChanged)="onFormChanged($event)" (inputBlurred)="onInputBlurred()" />

    @if (isWienerLinienVoucher) {
      <mwe-new-wl-voucher-form [wienerLinienVoucherDetail]="wienerLinienVoucherDetail" (wienerLinienInfo)="onWienerLinienInfo($event)" />
    }

    @if (codeValidity) {
      <ng-container [ngTemplateOutlet]="notifications" />
    }

    @if (config.campaignVoucher?.infoText) {
      <ng-container [ngTemplateOutlet]="infobox" />
    }
  </mwe-basic-card>

  @if (config.campaignVoucher?.faq?.length > 0) {
    <ng-container [ngTemplateOutlet]="faq" />
  }
}

<ng-template #notifications>
  @if (codeValidity === 'valid') {
    <div class="d-flex flex-column gap-3">
      @for (validMessageKey of validMessageKeys(); track $index) {
        <mwe-inline-notification [messageKey]="validMessageKey" [type]="'success'" />
      }
    </div>
  }
  @if (codeValidity === 'warning') {
    <mwe-inline-notification
      [titleKey]="warningItem.titleKey"
      [messageKey]="warningItem.messageKey"
      [ctaLabelKey]="warningItem.ctaLabelKey"
      (onCTAClick)="onCTAClick()"
      [type]="'warning'"
    />
  }
</ng-template>

<ng-template #infobox>
  <div class="mt-3">
    <mwe-infobox [messageKey]="config.campaignVoucher.infoText" />
  </div>
</ng-template>

<ng-template #faq>
  <div class="mt-5" data-test="new-voucher-faq" role="complementary">
    <h2>{{ 'newVoucher.faq' | translate }}</h2>
    <mwe-link-list-group [items]="config.campaignVoucher.faq" />
  </div>
</ng-template>
